export default __webpack_public_path__ + "static/media/icon.8ac964b9.png";